module.exports = __webpack_public_path__ + "static/media/no_lights@2x.fc300279.png";